import Dialog from "@mui/material/Dialog";
import { styled } from "@mui/material/styles";
import { CsiImage, Text } from "designSystem/index";
import React, { useState } from "react";
import CssColumnGrid from "../../CssColumnGrid";
import imageL from "./Landscape.jpg";
import imageLT from "./LandscapeThumbnail.jpg";
import imageP from "./Portrait.jpg";
import imagePT from "./PortraitThumbnail.jpg";

const PREFIX = "Lightbox";

const classes = {
	lightbox: `${PREFIX}lightbox`,
};

const StyledCssColumnGrid = styled(CssColumnGrid)(({
	theme,
}) => ({
	[`& .${classes.lightbox}`]: {
		backgroundColor: "rgba(0,0,0,0.5)",
		borderRadius: 0,
		boxSizing: "border-box",
		height: "100%",
		margin: 0,
		maxHeight: "100%",
		maxWidth: "100%",
		padding: 20,
		width: "100%",
	},
}));

export default () => {
	const [image, setImage] = useState(null);


	return (
		<StyledCssColumnGrid columns={2}>
			<Text semiBold text="landscape" />
			<Text semiBold text="portrait" />
			<CsiImage
				onClick={() => setImage(imageL)}
				size="small"
				src={imageLT}
			/>
			<CsiImage
				onClick={() => setImage(imageP)}
				size="small"
				src={imagePT}
			/>
			<Dialog
				classes={{ paper: classes.lightbox }}
				onClose={() => setImage(null)}
				open={!!image}
			>
				<CsiImage src={image} />
			</Dialog>
		</StyledCssColumnGrid>
	);
};